import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import useMaterialsData from "../../hooks/useMaterialsData";
import { toast } from "react-toastify";
import tableIcons from "../../config/tableIcons";
import { Button, Dialog, DialogActions, DialogContent, TextField } from "@material-ui/core";
import { ContainerBox, Line, QuantityInput } from "./styles";
import List from "../../components/List";
import NavTabs from "../../components/NavTabs";
import SideBar from "../../components/SideBar";
import Label from "../../components/Label";

const MaterialsPage = () => {
    const history = useHistory();

    const { materials, fetchMaterials, loading, error, updateMaterial, newMaterial, deleteMaterial } =
        useMaterialsData(true); // Busca automática
    const [selectedMaterial, setSelectedMaterial] = useState(null);
    const [dialogDelete, setDialogDelete] = useState(false);
    const [dialogEdit, setDialogEdit] = useState(false);
    const [dialogCreate, setDialogCreate] = useState(false);

    const [formValues, setFormValues] = useState({
        name: "",
        desc: "",
        qtd: "",
    });

    const handleOpenDelete = (material) => {
        setSelectedMaterial(material);
        setDialogDelete(true);
    };
    const handleCloseDelete = () => {
        setSelectedMaterial(null);
        setDialogDelete(false);
    };

    const handleOpenEdit = (material) => {
        setSelectedMaterial(material);
        setFormValues({ ...material });
        setDialogEdit(true);
    };
    const handleCloseEdit = () => {
        setSelectedMaterial(null);
        setFormValues({ name: "", desc: "", qtd: "" });
        setDialogEdit(false);
    };

    const handleOpenCreate = () => {
        setFormValues({ name: "", desc: "", qtd: "" });
        setDialogCreate(true);
    };
    const handleCloseCreate = () => {
        setFormValues({ name: "", desc: "", qtd: "" });
        setDialogCreate(false);
    };

    const handleDeleteMaterial = async () => {
        try {
            const deleted = await deleteMaterial(selectedMaterial.id);
            if (deleted) toast.success("Material excluído com sucesso!");
            else throw new Error("Error deleting");
            // fetchMaterials();
            window.location.reload();
        } catch (error) {
            console.error("Erro ao excluir material:", error);
            toast.error("Erro ao excluir material.");
        } finally {
            handleCloseDelete();
        }
    };

    const handleSaveEdit = async () => {
        try {
            const updated = await updateMaterial(formValues.id, formValues);
            if (updated) toast.success("Material atualizado com sucesso!");
            else throw new Error("Error updating");
            // fetchMaterials();
            window.location.reload();
        } catch (error) {
            console.error("Erro ao editar material:", error);
            toast.error("Erro ao editar material.");
        } finally {
            handleCloseEdit();
        }
    };

    const handleSaveCreate = async () => {
        try {
            const createdMaterial = await newMaterial(formValues);
            if (createdMaterial) toast.success("Material criado com sucesso!");
            else throw new Error("Error creating");
            // fetchMaterials();
            window.location.reload();
        } catch (error) {
            console.error("Erro ao criar material:", error);
            toast.error("Erro ao criar material.");
        } finally {
            handleCloseCreate();
        }
    };

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };

    const columns = [
        { field: "name", title: "Nome" },
        { field: "desc", title: "Descrição" },
        { field: "qtd", title: "Quantidade" },
        { field: "createdAt", title: "Criado em" },
    ];

    const actions = [
        (rowData) => ({
            icon: tableIcons.Edit,
            tooltip: "Editar Material",
            onClick: () => handleOpenEdit(rowData),
        }),
        (rowData) => ({
            icon: tableIcons.Delete,
            tooltip: "Excluir Material",
            onClick: () => handleOpenDelete(rowData),
        }),
    ];

    const deleteDialog = (
        <Dialog onClose={handleCloseDelete} open={dialogDelete}>
            <ContainerBox className="content">
                <DialogContent>
                    <Label size="medium" color="dark" weight="700">
                        Excluir Material
                    </Label>
                    <Label size="nano" color="black">
                        Tem certeza que deseja excluir o material <b>{selectedMaterial?.name}</b>?
                    </Label>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDelete} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleDeleteMaterial} color="primary">
                        Excluir
                    </Button>
                </DialogActions>
            </ContainerBox>
        </Dialog>
    );

    const editDialog = (
        <Dialog onClose={handleCloseEdit} open={dialogEdit}>
            <ContainerBox className="content">
                <DialogContent>
                    <Label size="medium" color="dark" weight="700">
                        Editar Material
                    </Label>
                    <TextField
                        label="Nome"
                        name="name"
                        value={formValues.name}
                        onChange={handleFormChange}
                        fullWidth
                        margin="dense"
                    />
                    <TextField
                        label="Descrição"
                        name="desc"
                        value={formValues.desc}
                        onChange={handleFormChange}
                        fullWidth
                        margin="dense"
                    />
                    <QuantityInput
                        label="Quantidade"
                        name="qtd"
                        type="number"
                        min="0"
                        value={formValues.qtd}
                        onChange={handleFormChange}
                        onWheel={(e) => e.target.blur()}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseEdit} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleSaveEdit} color="primary">
                        Salvar
                    </Button>
                </DialogActions>
            </ContainerBox>
        </Dialog>
    );

    const createDialog = (
        <Dialog onClose={handleCloseCreate} open={dialogCreate}>
            <ContainerBox className="content">
                <DialogContent>
                    <Label size="medium" color="dark" weight="700">
                        Criar Material
                    </Label>
                    <TextField
                        label="Nome"
                        name="name"
                        value={formValues.name}
                        onChange={handleFormChange}
                        fullWidth
                        margin="dense"
                    />
                    <TextField
                        label="Descrição"
                        name="desc"
                        value={formValues.desc}
                        onChange={handleFormChange}
                        fullWidth
                        margin="dense"
                    />
                    <QuantityInput
                        label="Quantidade"
                        placeholder="Quantidade"
                        name="qtd"
                        type="number"
                        min="0"
                        value={formValues.qtd}
                        onChange={handleFormChange}
                        onWheel={(e) => e.target.blur()}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseCreate} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleSaveCreate} color="primary">
                        Criar
                    </Button>
                </DialogActions>
            </ContainerBox>
        </Dialog>
    );

    const data = [
        {
            name: "Materiais",
            content: (
                <>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleOpenCreate}
                        style={{ marginBottom: "16px" }}
                    >
                        Criar Material
                    </Button>
                    <List
                        columns={columns}
                        rows={materials || []}
                        actions={actions}
                        loading={loading}
                        getRows={fetchMaterials}
                    />
                </>
            ),
        },
    ];

    const page = (
        <>
            <Line>
                <Label size="min" color="dark" weight="500">
                    Gerenciamento de Materiais
                </Label>
            </Line>
            {deleteDialog}
            {editDialog}
            {createDialog}
            <div style={{ maxWidth: "100%" }}>
                <NavTabs itens={data} />
            </div>
            {error && (
                <Label size="nano" color="red">
                    Ocorreu um erro ao carregar os materiais. Por favor, tente novamente.
                </Label>
            )}
        </>
    );

    return <SideBar current="Materiais" content={page} />;
};

export default MaterialsPage;
